var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClearSearchTextDisabled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4l-6 6M4 4l6 6",
    strokeWidth: 0.75
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSearchTextDisabled);
export default __webpack_public_path__ + "static/media/clear-search-text-disabled.0d8baae7.svg";
export { ForwardRef as ReactComponent };